// extracted by mini-css-extract-plugin
export default {"form-label":"Label_form-label__gVEt8","form-input":"Label_form-input__KR6-N","form-label__title":"Label_form-label__title__dHlyu"};